import { NgModule } from 'ng-metadata/core';
const localForageModule = require('angular-localforage');
import {ModelService} from './model.service';
import {PrmModel} from './model.directive';

@NgModule({
    declarations: [PrmModel],
    providers: [
        ModelService
    ],
    imports:[
        localForageModule
    ]
})
export class ModelModule {}


// WEBPACK FOOTER //
// ./src/main/webapp/components/infra/dataStructures/model/model.module.ts